"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
require("./StatePriv.css");
var __1 = require("..");
function StatePriv(_a) {
    var Icon = _a.icon, title = _a.title, text = _a.text, action = _a.action;
    return (React.createElement("div", { className: "nimbus--state-priv" },
        React.createElement("div", { className: "nimbus--state-priv__icon" },
            React.createElement(Icon, { size: "large" })),
        React.createElement("div", { className: "nimbus--state-priv__content" },
            React.createElement(__1.Text, { block: true, appearance: "secondary", textAlign: "center", bold: true }, title),
            text && (React.createElement(__1.Text, { block: true, appearance: "light", textAlign: "center", size: "caption" }, text)),
            action && (React.createElement(__1.Link, { onClick: action.onClick, underline: true }, action.children)))));
}
exports.default = StatePriv;
//# sourceMappingURL=index.js.map